import ApplicationSerializer from "./application";

export default class NetworkCircuitSerializer extends ApplicationSerializer {
  usesProxy = true;
}
